export default __webpack_public_path__ + "static/media/detail-note4.915baa67.svg";